export const vsv = {
  accept: "Acceptar",
  annotations: "Notes",
  areas: "ODS",
  authentication_error:
    "Les dades semblen incorrectes. Revisa-les i torna-ho a intentar.",
  book_abstract: "Resum del llibre",
  catalog_header: "Catàleg",
  clear_filters: "Netejar filtres",
  collections: "Col·leccions",
  bookmarks: "Marcadors",
  books: "Llibres",
  filter_catalog_option: "Catàleg",
  filter_my_books_option: "Els meus llibres",
  filter_teacher_books_option: "Del professor",
  filters_title: "Filtra",
  genres: "Gènere",
  languages: "Idiomes",
  logo_login: "",
  login_with_google: "Inicia sessió amb Google",
  login_legend: "INICIA SESSIÓ",
  login_submit: "Inicia sessió",
  logo_login: "imgs/login/logo.png",
  logout: "Tanca sessió",
  no_results: "No s'han trobat resultats",
  open: "Llegir",
  password_lost: "He oblidat la meva contrasenya",
  password_placeholder: "Contrasenya",
  password_recovery_header: "¿Olvidaste tu contraseña?",
  password_recovery_legend:
    "Escribe tu dirección de correo electrónico y te enviaremos los datos de acceso.",
  password_recovery_submit: "Recuperar",
  password_recovery_ok:
    "En breve recibirás un correo electrónico con los datos de acceso",
  password_recovery_error:
    "El correo electrónico proporcionado no corresponde a ningún usuario registrado",
  publishers: "Editorials",
  read: "Llegir llibre",
  ages: "Edat recomanada",
  remove_from_my_books: 'Elimina d\'"Els meus llibres"',
  search: "Busca",
  search_input: "Busca ...",
  signin_legend: "Si encara no tens un compte",
  signin_link: "registra't ací",
  subjects: "Temàtiques",
  username_placeholder: "Correu electrònic",
  values: "Valors",
  education_levels: "Niveles educativos",
  typologies: "Recursos",
  view_abstract: "Resum",
  requestCase: "Votar",
  addClass: "Afig a la meua classe",
  addBook: "Afig llibre",
  add: "Afig",
  selectClasses: "Selecciona una o més classes per a afegir el llibre",
  wait: "Espera...",
  addWithSuccess: "Llibre afegit correctament a la classe.",
  cancel: "Cancel·la",
  detective: "investigador",
  detectives: "investigadors",
  noDetectives: "Sense detectius",
  requestCaseSuccess: "Votat",
  requestCaseDescription: (
    <>
      <p>T'agradaria tenir disponible un cas sobre aquest llibre?</p>
      <p>
        Si vols una proposta didàctica per treballar aquesta lectura amb
        l’alumnat, fes clic a “Votar”.
      </p>
      <p>
        El recompte dels vots ens ajuda a decidir quins seran els pròxims casos
        disponibles a Ta-tum.
      </p>
      <p>
        Si finalment creem aquest cas, t'enviarem un correu electrònic per a
        informar-te.
      </p>
      sendWithSuccess: "Hem rebut el teu vot.<p>Moltes gràcies!</p>
    </>
  ),
  requestTitle: "Vota!",
  moreReadings: "Més llegits",
  moreRecents: "Més recents",
  orderAsc: "Ordenació A-Z",
  orderDesc: "Ordenació Z-A",
  orderBy: "Ordena per",
  urlSuscribe: "https://ta-tum.com/#register",
  applyFilters: "Aplica filtres",
  legal: "Avís Legal",
  privacy: "Política de Privacitat",
  cookies: "Política de cookies",
  edelvives: "Grupo Edelvives",
  edelvivesLink: "https://www.edelvives.com/es/index",
};
